"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const client_1 = __importDefault(require("../../client"));
const path = (id) => `/team/${id}`;
function getTeam(team, options) {
    const id = team.split(':')[1];
    const params = {};
    const headers = new axios_1.AxiosHeaders();
    if ((options === null || options === void 0 ? void 0 : options.roster) === true) {
        params.roster = 'true';
    }
    if ((options === null || options === void 0 ? void 0 : options.events) === true) {
        params.events = 'true';
    }
    if ((options === null || options === void 0 ? void 0 : options.token) !== undefined) {
        headers.set('Authorization', options.token);
    }
    return client_1.default.get(path(id), {
        params,
        headers,
    });
}
exports.default = getTeam;
